import { Component, OnInit } from '@angular/core';
import { MasterDataService } from '../../services/master-data.service';
import { NgModel } from '@angular/forms';
import * as moment from 'moment';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';

@Component({
  selector: 'app-monthly-conveyance-detail-report',
  templateUrl: './monthly-conveyance-detail-report.component.html',
  styleUrls: ['./monthly-conveyance-detail-report.component.css'],
})
export class MonthlyConveyanceDetailReportComponent implements OnInit {
  selectedFinancialYear;
  financialList;
  branchList;
  closingDateList;
  selectedClosing;
  selectedEmployee;
  selectedRole;
  roleList;
  selectedBranch;
  isRoleSelected = false;
  isBranchSelected = false;
  monthlyConveyanceDetailList;
  chargableTotal;
  nonChargableTotal;
  allChargablenonChargableTotal;
  closingDate;
  daywiseConveyanceList;
  showDaywiseConveyanceDetails = false;
  showMonthlyConveyanceDetails = true;
  totalDistance;
  totalRate;
  totalConveyance;
  employeeName;
  userRole;
  accessResponse: any;

  constructor(private masterDataService: MasterDataService, private commonMessageService: CommonMessageService,
    private branchFilterService: BranchFilterService
  ) { }

  ngOnInit(): void {
    this.selectedFinancialYear = '';
    this.selectedClosing = '';
    this.selectedEmployee = '1';
    this.selectedBranch = '';
    this.loadInitialDetails();
  }

  loadInitialDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });

    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchList = res;
    // });

    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });

    this.masterDataService.getRoles().subscribe((res) => {
      this.roleList = res;
    });
  }

  onFinancialYearSelected() {
    if (
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined &&
      this.selectedFinancialYear != ''
    ) {
      this.masterDataService
        .getClosingDatesByFinancialYear(this.selectedFinancialYear.id)
        .subscribe((res) => {
          this.closingDateList = res;
          var notClosedobject = {
            id: 0,
            closingDate: 'Not Closed',
          };
          this.closingDateList.push(notClosedobject);
          console.log('closing date list', this.closingDateList);
        });
    }
    this.selectedClosing = '';
  }

  selectAllRole(select: NgModel, values) {
    this.selectAll(select, values, this.isRoleSelected, false);
    this.isRoleSelected = !this.isRoleSelected;
  }
  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected, false);
    this.isBranchSelected = !this.isBranchSelected;
  }
  selectAll(select: NgModel, values, isSelected, isId) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  roleId;
  branchId;
  onViewReport() {
    console.log('select closing', this.selectedClosing);
    if (
      this.selectedFinancialYear == null ||
      this.selectedFinancialYear == undefined ||
      this.selectedFinancialYear == '' ||
      this.selectedClosing == null ||
      this.selectedClosing == '' ||
      this.selectedBranch == null ||
      this.selectedBranch.length === 0 ||
      this.selectedRole == null ||
      this.selectedRole.length === 0
    ) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please choose all the values');
      return;
    }
    this.roleId = this.selectedRole.map(({ id }) => id);
    this.branchId = this.selectedBranch.map(({ id }) => id);
    console.log('closing date id', this.selectedClosing.id);
    console.log('role id', this.roleId);
    console.log('branch id', this.branchId);
    console.log('Status', this.selectedEmployee);
    this.masterDataService
      .getMonthlyConveyanceDetailReport(
        this.selectedClosing.id,
        this.roleId,
        this.branchId,
        this.selectedEmployee
      )
      .subscribe((res) => {
        console.log('monthly conveyance report', res);
        this.monthlyConveyanceDetailList = res;
        if (this.monthlyConveyanceDetailList == null) {
          this.commonMessageService.swalAlertWithoutIcon('', 'No Record Found.');
          this.showExportToExcelButton = false;
        } else {
          this.showExportToExcelButton = true;
        }
      });
  }

  showExportToExcelButton: boolean;
  exportToExcelMonthlyCoveyance() {
    this.masterDataService
      .getMonthlyConveyanceReportExcel(
        this.selectedClosing.id,
        this.roleId,
        this.branchId,
        this.selectedEmployee
      )
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "MonthlyConveyanceDetailReport.xlsx";
        link.click();
      });
  }

  setRowSpanForBranchDetails(branchDetails) {
    var count = 0;
    branchDetails.details.map((res) => {
      res.periodDetails.map((res1) => {
        count++;
      });
    });
    return count;
  }
  changeMonthNumberToName(month) {
    return moment(month, 'M').format('MMM');
  }
  getChargableTotal(periodDetails) {
    this.chargableTotal = 0;
    periodDetails.map((res) => {
      this.chargableTotal += res.chargeble;
    });
    return this.chargableTotal;
  }

  getNonChargableTotal(periodDetails) {
    this.nonChargableTotal = 0;
    periodDetails.map((res) => {
      this.nonChargableTotal += res.nonChargeble;
    });
    return this.nonChargableTotal;
  }

  getChargableNonChargableTotal(periodDetails) {
    this.allChargablenonChargableTotal = 0;
    periodDetails.map((res) => {
      this.allChargablenonChargableTotal +=
        res.chargeble + res.nonChargeble;
    });
    return this.allChargablenonChargableTotal;
  }

  //All Total
  getAllChargableTotal(branchDetails) {
    this.chargableTotal = 0;
    branchDetails.map((res) => {
      res.details.map((res1) => {
        res1.periodDetails.map((res2) => {
          this.chargableTotal += res2.chargeble;
        });
      });
    });
    return Math.round(this.chargableTotal);
  }
  getAllNonChargableTotal(branchDetails) {
    this.nonChargableTotal = 0;
    branchDetails.map((res) => {
      res.details.map((res1) => {
        res1.periodDetails.map((res2) => {
          this.nonChargableTotal += res2.nonChargeble;
        });
      });
    });
    return Math.round(this.nonChargableTotal);
  }

  getAllChargableNonChargableTotal(branchDetails) {
    this.allChargablenonChargableTotal = 0;
    branchDetails.map((res) => {
      res.details.map((res1) => {
        res1.periodDetails.map((res2) => {
          this.allChargablenonChargableTotal +=
            res2.chargeble + res2.nonChargeble;
        });
      });
    });
    return Math.round(this.allChargablenonChargableTotal);
  }

  goBack() {
    this.showDaywiseConveyanceDetails = false;
    this.showMonthlyConveyanceDetails = true;
  }

  //Daywise Conveyance details
  userId;
  month;
  year;
  getDaywiseConveyanceDetails(empFName, empLName, userId, month, year) {
    this.userId = userId;
    this.month = month;
    this.year = year;
    this.employeeName = empFName.concat(' ', empLName);
    console.log('employee name', this.employeeName);
    this.showDaywiseConveyanceDetails = true;
    this.showMonthlyConveyanceDetails = false;
    this.masterDataService.getDaywiseConveyanceDetailReport(this.selectedClosing.id, userId, month, year).subscribe((res: any) => {
      console.log('daywise conveyance response', res);
      this.daywiseConveyanceList = res;
      this.allDetailsTotal();
    })
  }

  allDetailsTotal() {
    this.totalDistance = 0;
    this.totalRate = 0;
    this.totalConveyance = 0;
    var totalDistanceCount = 0;
    var totalRateCount = 0;
    var totalConveyanceCount = 0;
    this.daywiseConveyanceList.map((res: any) => {
      totalDistanceCount += res.distanceFromOffice;
      this.totalDistance = Math.round(totalDistanceCount);
      totalRateCount += res.rate;
      this.totalRate = Math.round(totalRateCount);
      totalConveyanceCount += res.conveyance;
      this.totalConveyance = Math.round(totalConveyanceCount);
    })
  }

  exportToExcelDaywiseConveyance() {
    this.masterDataService.getDaywiseConveyanceReportExcel(this.selectedClosing.id, this.userId, this.month, this.year).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "DaywiseConveyanceReport.xlsx";
      link.click();
    });
  }
}
